import React from "react";
import InitialPropsContext from "../lib/models/initialPropsContext";
import PageNotFoundError from "../lib/pageNotFoundError";
import ProgramPage from "../components/program/ProgramPage";
import { Props } from "../components/program/ProgramPage";
import PageProps from "../lib/models/pageProps";

export default function Program(props: Props) {
  return <ProgramPage {...props} />;
}

Program.getInitialProps = async ({
  api,
  query,
  asPath,
  pathname
}: InitialPropsContext): PageProps<Props> => {
  const { slug, category } = query;
  let breadCrumpPath = [];
  let extraFetch = Promise.resolve(undefined);
  let portraitFetch = Promise.resolve(undefined);

  if (pathname === "/program") {
    extraFetch = api.loadCategoryBySlug(category as string);
    portraitFetch = api
      .listMagazinPortraits({
        limit: 6,
        orderBy: "date",
        order: "desc",
        categories: { eq: category, path: "slug" }
      })
      .catch(() => ({ total: 0, items: [] }));
  } else if (pathname === "/partnerCategoryProgram") {
    extraFetch = api.loadPartnerCategoryBySlug(category as string);
  }

  const [content, extra, portraits] = await Promise.all([
    api.loadProgramBySlug(slug as string).catch(() => {
      throw new PageNotFoundError();
    }),
    extraFetch.catch(() => {}),
    portraitFetch
  ]);
  if (extra && pathname === "/program") {
    breadCrumpPath = [
      {
        route: "segment",
        title: extra.categoryCluster.segment.name,
        params: {
          segment: extra.categoryCluster.segment.slug
        }
      },
      {
        route: "categoryCluster",
        title: extra.categoryCluster.name,
        params: {
          segment: extra.categoryCluster.segment.slug,
          categoryCluster: extra.categoryCluster.slug
        }
      },
      {
        route: "category",
        title: extra.name,
        params: {
          segment: extra.categoryCluster.segment.slug,
          categoryCluster: extra.categoryCluster.slug,
          category: extra.slug
        }
      },
      {
        route: "program",
        title: content.name,
        params: {
          segment: extra.categoryCluster.segment.slug,
          categoryCluster: extra.categoryCluster.slug,
          category: extra.slug,
          slug: content.slug
        }
      }
    ];
  } else if (extra && pathname === "/partnerCategoryProgram") {
    breadCrumpPath = [
      {
        route: "partners",
        title: "Partner"
      },
      {
        route: "partnerGroup",
        params: {
          slug: extra.group.slug
        },
        title: extra.group.name
      },
      {
        route: "partnerCategory",
        params: {
          slug: extra.slug,
          group: extra.group.slug
        },
        title: extra.name
      },
      {
        route: "partnerCategoryProgram",
        title: content.name,
        params: {
          category: extra.slug,
          group: extra.group.slug,
          slug: content.slug
        }
      }
    ];
  } else {
    breadCrumpPath = [
      {
        route: "shortProgram",
        title: content.name,
        params: {
          slug: content.slug
        }
      }
    ];
  }

  const pageProps = {
    ...content,
    url: asPath,
    breadCrumpPath,
    relatedPortraits: portraits
  };

  let _pageImages;

  try {
    _pageImages = ProgramPage.getImages(pageProps);
  } catch (error) {
    console.error(error);
  }
  return {
    ...pageProps,
    _pageImages
  };
};
